<template>
  <div class="rounded-lg shadow-none">
    <div class="d-flex align-items-end justify-content-start mb-4 px-4" style="gap: 10px"
      v-if="isSelectAll || selectedItem.length">
        <Button
         v-if="roleID !== 5"
          @click="onSubmitUnPublishSelected" 
          :disabled="isLoadingUnPublish"
            variant="default"
            size="sm"
            class="mr-2 bg-red-500 text-white"
            color="red"
            >
          
           <b-spinner small v-if="isLoadingUnPublish"></b-spinner>
        <em class="fa fa-eye-slash" v-else></em>
        UnPublished
          </Button>
      <label for="" v-if="roleID !== 5">{{ selectedItem.length }} selected item</label>
    </div>
    <Table :headers="headers" :data="books"
      :withSelectable="roleID !== 5? true : false"
      :row-key="['name','id', 'content_type', 'is_active', 'item_status', 'page_count', 'file_size', 'vendor']"
      :current-page="currentPage"   
      @row-selected="onRowSelected" ref="tableList" class="shadow-none"
      @toggle-row="toggleRowSelection"
      :selectedItem.sync="selectedItem" 
      :isLoading="isLoading" :per-page="perPage">
      <template #header-create="{ column }">
        <div class="flex items-center gap-1">
          {{ column.label }}
          <button @click="sortBy(column.key)" class="text-xs text-gray-500">
            <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
              </svg>
            </span>
          </button>
        </div>
      </template>
      <template #header-modified="{ column }">
        <div class="flex items-center gap-1">
          {{ column.label }}
          <button @click="sortBy(column.key)" class="text-xs text-gray-500">
            <span href="#"><svg class="w-3 h-3 ms-1.5" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
                fill="currentColor" viewBox="0 0 24 24">
                <path
                  d="M8.574 11.024h6.852a2.075 2.075 0 0 0 1.847-1.086 1.9 1.9 0 0 0-.11-1.986L13.736 2.9a2.122 2.122 0 0 0-3.472 0L6.837 7.952a1.9 1.9 0 0 0-.11 1.986 2.074 2.074 0 0 0 1.847 1.086Zm6.852 1.952H8.574a2.072 2.072 0 0 0-1.847 1.087 1.9 1.9 0 0 0 .11 1.985l3.426 5.05a2.123 2.123 0 0 0 3.472 0l3.427-5.05a1.9 1.9 0 0 0 .11-1.985 2.074 2.074 0 0 0-1.846-1.087Z" />
              </svg>
            </span>
          </button>
        </div>
      </template>
      <template #header-no="{ column }">
        <div class="flex justify-start">
          <t-checkbox v-if="roleID !== 5" class="mr-2 ml-2" v-model="isSelectAll" @input="onSelectAllRows">
          </t-checkbox>
          {{ column.label }}
        </div>
      </template>
      <template #name="{ row }">
      
       <div
        v-if="row.item_status === 'uploading'"
        class="text-left flex justify-start items-center text-gray-600"
      >
        <span>{{ row.name }}</span>
      </div>
      <router-link
        v-else-if="row.item_type === 'book'"
        :to="{ name: ManageFormEbookPath.name, params: { id: row.id.toString() } }"
        class="text-center text-blue-700 hover:no-underline hover:text-blue-700"
      >
        {{ row.name }}
      </router-link>
      
      <span
        v-else 
        @click.prevent="actionEdit(row)"
        class="text-center text-blue-700 hover:no-underline hover:text-blue-700"
      >
        {{ row.name }}
    </span>
      </template>
       <template #id="{ value }">
        <span class="uppercase text-center">
          <button size="sm" variant="outline" @click.stop="copyTextToClipboard(value)" class="relative block border text-center p-1.5" style="border-radius: 7px;">
          <span class="flex justify-center  items-center top-0 text-center text-xs">
              {{ value }}
            <svg class="w-4 h-4 text-gray-400 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
              <path fill-rule="evenodd" d="M7 9v6a4 4 0 0 0 4 4h4a2 2 0 0 1-2 2H6a2 2 0 0 1-2-2V9a2 2 0 0 1 2-2h1v2Z"
                clip-rule="evenodd" />
              <path fill-rule="evenodd"
                d="M13 3.054V7H9.2a2 2 0 0 1 .281-.432l2.46-2.87A2 2 0 0 1 13 3.054ZM15 3v4a2 2 0 0 1-2 2H9v6a2 2 0 0 0 2 2h7a2 2 0 0 0 2-2V5a2 2 0 0 0-2-2h-3Z"
                clip-rule="evenodd" />
            </svg>
          
          </span>
        </button>
        </span>
      </template>
      
      <template #content_type="{ row }">
        <span v-if="row.item_status !== 'ready for upload'" class="uppercase">
          {{ row.content_type }}
        </span>
        <span v-else>
          -
        </span>
      </template>
      <template #is_active="{ value }">
        <span
          :class="[{ 'bg-green-100 text-green-800': value, 'bg-gray-200 text-gray-800': !value }, 'text-left rounded-lg text-xs p-1 px-2 ml-2']">
          {{ formatBoolean(value) }}
        </span>
      </template>
      <template #item_status="{ row }">
        <div class="w-36 block text-left px-2">
          <span :class="getStatusClass(row.item_status)" class="flex w-max" v-if="row.item_status ==='uploading'">
            <svg class="w-4 h-4 mr-1 text-orange-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="currentColor" viewBox="0 0 24 24">
  <path fill-rule="evenodd" d="M2 12C2 6.477 6.477 2 12 2s10 4.477 10 10-4.477 10-10 10S2 17.523 2 12Zm11-4a1 1 0 1 0-2 0v4a1 1 0 0 0 .293.707l3 3a1 1 0 0 0 1.414-1.414L13 11.586V8Z" clip-rule="evenodd"/>
</svg>
 {{ row.item_status }}
          </span>
          <span :class="getStatusClass(row.item_status)" v-else>
  {{ row.item_status }}
          </span>
        
        </div>
      </template>
      <!-- <template #printed_price="{ row }">
        {{
          formatPrice(row.printed_price, row.printed_currency_code)
        }}
      </template> -->
      <template #file_size="{ value }">
        <span class="w-16 block text-left">
          {{ convertMegaBite(value) }}
        </span>
      </template>
      <!-- <template #release_date="{ value }">
        <span>{{ formatDate(value).date }}</span>
        <br>
        <span class="italic text-xs">{{ formatDate(value).time }}</span>
      </template>

      <template #release_schedule="{ value }">
        <span>{{ formatDate(value).date }}</span>
        <br>
        <span class="italic text-xs">{{ formatDate(value).time }}</span>
      </template> -->
      <template #actions="{ row }">
        <div 
        @click.stop>
          <t-dropdown>
            
            <div slot="trigger" slot-scope="{
                mousedownHandler,
                focusHandler,
                blurHandler,
                keydownHandler,
                isShown
              }" @focus.stop="focusHandler" @blur.stop="blurHandler" @keydown.stop="keydownHandler"
              @click.stop="mousedownHandler">
              <button id="user-menu" 
                :class="{ ' text-gray-500 ': isShown, 'opacity-50':row.item_status === 'uploading' }" 
                :disabled="row.item_status === 'uploading'" 
                aria-label="User menu" aria-haspopup="true"
                @focus.stop="focusHandler" @blur.stop="blurHandler" 
                @keydown.stop="keydownHandler"
                @click.stop="mousedownHandler" 
                class="cursor-pointer focus:outline-none"
                >
                <i class="fa-solid fa-ellipsis"></i>
              </button>

            </div>

            <div slot-scope="{ hide, blurHandler }">
              <button
                  :class="{
                    hidden: roleID === 5,
                'opacity-50 pointer-events-none': [
                  'ready for consume',
                  'ready for upload',
                  'failed to upload'
                ].includes(row.item_status?.trim())
              }"
                class="block text-left w-full px-4 py-2 text-sm le  ading-5 text-gray-500 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                role="menuitem" @click.stop="hide" @blur="blurHandler">
                <div v-if="roleID !== 5" @click.stop="actionUpdateStatus(row, 'publish', status.Published)"
                  class="flex items-center">
                  <svg class="w-6 h-6 text-gray-500 dark:text-white" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-width="2"
                      d="M21 12c0 1.2-4.03 6-9 6s-9-4.8-9-6c0-1.2 4.03-6 9-6s9 4.8 9 6Z" />
                    <path stroke="currentColor" stroke-width="2" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                  </svg>
                  <span class="flex items-center ml-2">
                    Published
                  </span>
                </div>

              </button>
              <button
                :class="{
                hidden: roleID === 5,
                'opacity-50 pointer-events-none': [
                  'not for consume',
                  'need approval',
                  'ready for upload',
                  'failed to upload'
                ].includes(row.item_status?.trim())
              }"

                class="block text-left  w-full px-4 py-2 text-sm leading-5 text-gray-500 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                role="menuitem" @click.stop="hide" @blur="blurHandler">
                <div v-if="roleID !== 5" class="flex items-center" variant="danger"
                  @click.stop="actionUpdateStatus(row, 'unpublish', status.Unpublished)">

                  <svg class="w-6 h-6 text-gray-500 dark:text-white" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="M3.933 13.909A4.357 4.357 0 0 1 3 12c0-1 4-6 9-6m7.6 3.8A5.068 5.068 0 0 1 21 12c0 1-3 6-9 6-.314 0-.62-.014-.918-.04M5 19 19 5m-4 7a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                  </svg>
                  <span class="flex items-center ml-2">
                    UnPublished
                  </span>

                </div>
              </button>
              <button
                class="block text-left w-full px-4 py-2 text-sm leading-5 text-gray-500 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                role="menuitem" @click.stop="hide" @blur="blurHandler">
                <div variant="default" @click="actionEdit(row)" class="flex items-center">
                  <svg class="w-6 h-6 text-gray-500 dark:text-white" aria-hidden="true"
                    xmlns="http://www.w3.org/2000/svg" width="24" height="24" fill="none" viewBox="0 0 24 24">
                    <path stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                      d="m14.304 4.844 2.852 2.852M7 7H4a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h11a1 1 0 0 0 1-1v-4.5m2.409-9.91a2.017 2.017 0 0 1 0 2.853l-6.844 6.844L8 14l.713-3.565 6.844-6.844a2.015 2.015 0 0 1 2.852 0Z" />
                  </svg>
                  <span class="flex items-center ml-2">
                    Edit Items
                  </span>
                </div>
              </button>
              <!-- <button
                :class="roleID === 5 ? 'hidden' : '' || row.item_status === 'mcgrawhill content' ? 'opacity-50 pointer-events-none' : ''"
                class="block text-left w-full px-4 py-2 text-sm leading-5 text-gray-500 transition duration-150 ease-in-out hover:bg-gray-100 focus:outline-none focus:bg-gray-100"
                role="menuitem" @click.stop="hide" @blur="blurHandler">
                <div v-if="row.item_type != item_types_audio">
                  <div variant="black" @click="
                    actionUpdateStatus(
                      row,
                      'mcgrawhill content',
                      status.UnpublishedMcgrawhill,
                    )
                    " v-if="permBtnMcGraw()">
                    mcgrawhill content
                  </div>
                </div>
              </button> -->
            </div>
          </t-dropdown>
        </div>

      </template>
    </Table>

    <t-modal ref="confirmationModal">
      <div class="text-sm flex-col text-center">
        <label class="text-center font-semibold">Are You Sure?</label>
        <p class="text-left text-gray-500">This action is quite dangerous, do you still want to continue?</p>
      </div>
      <div class="flex justify-center">
        <button class="bg-blue-500 text-white p-1 px-2 rounded-lg mr-1 text-sm" @click="cancel">Cancel</button>
        <button class="bg-white border text-gray-500 p-1 px-2 rounded-lg ml-1 text-sm"
          @click="confirmBulkUnPublish">Yes</button>
      </div>
    </t-modal>

    <t-modal ref="modalUpdateStatus">
      <div class="text-sm flex-col">
        <div class="text-center" v-if="this.titleModalUpdateStatus === 'unpublish'">
             <label class="text-center text-lg font-semibold">
          <!-- Content {{ this.titleModalUpdateStatus }} ? -->
          Unpublished Content
          </label>
          <p>Once unpublished, it will no longer appear on the homepage, PDP, or in user search results.</p>
        </div>
        <div v-else>
           <label class="text-left font-semibold">
           Are you sure want to {{ this.titleModalUpdateStatus }} ?
          
          </label>
        <div>
            <p class="text-left text-gray-500">{{ nameModalUpdateStatus }} {{ this.statusModalUpdate }} </p>
        </div>
        </div>
       
      </div>
      <div class="flex justify-center" v-if="this.titleModalUpdateStatus === 'unpublish'">
            <Button
          @click="confirmUpdateStatus" 
          :disabled="isLoadingUnPublish"
            variant="default"
            size="xs"
            class="mr-3"
            >
            Unpublished
          </Button>
          <Button 
          size="xs"
           variant="outlined"
           color="alternative"
          @click="cancel"
          >Cancel</Button>
        
      </div>
      <div v-else class="flex justify-center">
        <Button
          @click="confirmUpdateStatus" 
            variant="default"
            size="xs"
            class="mr-3"
            >
            Published
          </Button>
          <Button 
          size="xs"
           variant="outlined"
           color="alternative"
          @click="cancel"
          >Cancel</Button>
      </div>
    </t-modal>
  </div>
</template>

<script>
import API from '../../plugins/http';
import moment from 'moment';
import constant from '../../store/constant';
import Button from '@/components/ui/Button';
import Table from '../../components/form/table.vue'
import {
//  BookEditPath,
  ManageFormEbookPath,
  DetailItems,
  MagazineEditPath,
  NewspaperEditPath,
  AudioEditPath,
  AudioEditChapterPath,
} from '../../router/content';
import { mapActions, mapGetters, mapState } from 'vuex';
import { EventBus } from '../../../src/event-bus';
const { ROLES } = constant;
const McGrawHill = [1001]; // McGraw-Hill Education

export default {
  name: 'Books',
  components: {
    Table,
    Button
  },
  props: {
    books: {
      type: Array,
      required: true,
    },
    perPage: {
      type: Number,
      required: true,
    },
    currentPage: {
      type: Number,
      required: true,
    },
    isLoading: {
      type: Boolean,
      required: true,
    },
    reloadPage: {
      type: Function,
      required: false,
      default() { },
    },
  },
  data() {
    return {
      showModal: false,
      roleID: JSON.parse(localStorage.getItem("session_auth")).role_id,
      Form: {
        id: null,
        id_ax: null,
      },
      sortOrder: 'desc',
      confirmed: false,
      statusModalUpdate: '',
      nameModalUpdateStatus: '',
      titleModalUpdateStatus: '',
      dataItemModalUpateStatus: '',
      item_types_audio: 'audio book',
      headers: [
        { label: 'No', key: '' },
        { label: 'Book name', key: '' },
        {label: 'ID', key: ''},
        { label: 'type', key: '' },
        { label: 'visibility', key: '' },
        { label: 'Content status', key: '' },
        // { label: 'printed price', key: '' },
        { label: 'Page Count', key: '' },
        { label: 'Size', key: '' },
        // { label: 'Release Date', key: '', sortable: true, slotHeader: 'header-create' },
        // { label: 'Release schedule', key: '', sortable: true, slotHeader: 'header-modified' },
        { label: 'Publisher', key: '' }
      ],
      fields: [
        {
          key: 'no',
          label: 'No',
          tdClass: 'text-uppercase',
        },
        {
          key: 'title',
          label: 'Name',
          tdClass: 'text-uppercase',

        },
        {
          key: 'content_type',
          tdClass: 'text-uppercase',
        },
        {
          key: 'is_active',
          label: 'Is Active',
          formatter: (value) => {
            return value ? 'Yes' : 'No';
          },
          sortByFormatted: true,
          filterByFormatted: true,
        },
        {
          key: 'item_status',
          label: 'Item Status',
          thClass: 'text-capitalize',
          tdClass: 'text-capitalize',
          tdStyle: { width: '250px' },
          sortByFormatted: true,
          filterByFormatted: true,
        },
        {
          key: 'printed_price',
          label: 'Printed Price',
          thClass: 'text-right',
          tdStyle: { width: '300px' },
        },
        {
          key: 'page_count',
          label: 'Page Count',
        },
        {
          key: 'size',
          label: 'Size',
          thClass: 'text-right',
        },
        {
          key: 'release_date',
          label: 'Release Date',
          formatter: (value) => {
            return moment(value).format('DD MMM YYYY');
          },
        },
        {
          key: 'release_schedule',
          label: 'Release schedule',
          formatter: (value) => {
            return moment(value).format('DD MMM YYYY');
          },
        },
        { key: 'vendor_name', label: 'Vendor' },
        { key: 'status', label: 'Action' },
      ],
      DetailItems,
      ManageFormEbookPath,
      
      status: {
        Published: constant.ITEM_STATUS['Ready For Consume'],
        Unpublished: constant.ITEM_STATUS['Not For Consume'],
        UnpublishedMcgrawhill: constant.ITEM_STATUS.UnpublishedMcgrawhill,
      },
      itemStatus: constant.ITEM_STATUS,
      isSelectAll: false,
      isLoadingUnPublish: false,
      selectedItem: [],
    };
  },
  watch: {
    books() {
      this.isSelectAll = false;
      this.selectedItem = []
    },
  },
  computed: {
    ...mapGetters('auth', { auth: 'auth' }),
    ...mapState({
      ownVendor: (state) => state.vendors.item,
    }),
  },
  created() {
    this.fetchOwnVendors();
  },
  methods: {
    ...mapActions('vendors', ['fetchOwnVendors']),
    ...mapActions('items', ['bulkUnPublish']),
    formatPrice(value, currency) {
      currency = currency || 'IDR';
      if (value) {
        let formatter = null;
        if (currency === 'USD') {
          formatter = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: currency,
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
            useGrouping: true,
          });
        } else {
          formatter = new Intl.NumberFormat('id-ID', {
            style: 'currency',
            currency: currency,
            maximumFractionDigits: 0,
            minimumFractionDigits: 0,
            useGrouping: true,
          });
        }
        return formatter.format(value);
      }
      return '0';
    },
    formatDate(tgl) {
      return {
        date: moment(tgl).format('DD MMM YY'),
        time: moment(tgl).format('HH:mm:ss'),
      };
    },
    convertMegaBite(size) {
      if (size) {
        return (size / 1000 ** 2).toFixed(1) + ' MB';
      }
      return '0';
    },
    actionSend() {
      let payload = {
        id_ax: this.Form.id_ax,
        id: this.Form.id,
      };
      API.post('ofs-catalog', payload)
        .then((response) => {
          console.log('response', response);
          this.$swal({
            icon: 'success',
            toast: true,
            position: 'top-end',
            title: 'Success send ofs',
            timer: 3000,
            text: this.message,
          });
        })
        .catch((error) => {
          console.log('ini error', error);
          this.$swal({
            icon: 'error',
            toast: true,
            position: 'top-end',
            title: 'Failed send ofs',
            timer: 3000,
            text: this.message,
          });
        });
    },
    actionSendOfs(item) {
      this.showModal = true;
      this.Form.id = item.id;
    },
    getStatusClass(status) {

      const statusClasses = {
        [this.itemStatus['Not For Consume']]: 'bg-gray-100 text-gray-800',
        [this.itemStatus['Failed To Upload']]: 'bg-red-100 text-red-800',

        [this.itemStatus.Uploaded]: 'bg-yellow-100 text-yellow-800',
        [this.itemStatus['Ready For Consume']]: 'bg-blue-100 text-blue-800',

        [this.itemStatus['Ready For Upload']]: 'bg-purple-100 text-purple-800',
        [this.itemStatus.Uploading]: 'bg-orange-100 text-orange-800',

        [this.itemStatus.UnpublishedMcgrawhill]: 'bg-gray-100 text-gray-800',
        [this.itemStatus['Need Approval']]: 'bg-yellow-100 text-yellow-800',
};

      const baseClasses = 'rounded-lg text-xs p-1';
      return `${baseClasses} ${statusClasses[status] || 'bg-green-100 text-green-800'}`;
    },
      toggleRowSelection(data) {
    const blockedStatus = [
    'uploading',
    'ready for upload',
    'failed to upload',
    'not for consume',
    'need approval',
  ];

if (!data || blockedStatus.includes(data.item_status)) return;


    const index = this.selectedItem.indexOf(data.id);
    if (index === -1) {
      this.selectedItem.push(data.id);
    } else {
      this.selectedItem.splice(index, 1);
    }
  },
    mapUrl(item) {
      const itemType = constant.ITEM_TYPES;
      if (item.item_type == itemType.BOOK.toLowerCase()) {
        return ManageFormEbookPath.name;
      }
      if (item.item_type == itemType.MAGAZINE.toLowerCase()) {
        return MagazineEditPath.name;
      }
      if (item.item_type == itemType.NEWSPAPER.toLowerCase()) {
        return NewspaperEditPath.name;
      }
      if (item.item_type == itemType.AUDIOBOOK.toLowerCase()) {
        return AudioEditPath.name;
      }
      if (item.item_type == 'Chapter') {
        return AudioEditChapterPath.name;
      }
    },
    actionEdit(item) {
      this.$router.push({
        name: this.mapUrl(item),
        params: {
          id: item.id.toString(),
        },
      });
    },
    actionSendAx(item) {
      let payload = {
        id: item.id,
      };
      API.post('register-ax', payload)
        .then(() => {
          EventBus.$emit('show-toast', {
            message: 'Success send ax',
            type: 'success',
          });
        })
        .catch((error) => {
          console.log(error)
          EventBus.$emit('show-toast', {
            message: 'Failed send ax',
            type: 'error',
          });
        });
    },

    actionSendAxPremium(item) {
      let payload = {
        id: item.id,
      };
      API.post('register-ax/premium', payload)
        .then(() => {
          EventBus.$emit('show-toast', {
            message: 'Success send ax premium item.',
            type: 'success',
          });
        })
        .catch((err) => {
          if (err.response.status == 404) {
            EventBus.$emit('show-toast', {
              message: 'Book not Found',
              type: 'error',
            });
          } else {
            EventBus.$emit('show-toast', {
              message: err.response.data.message,
              type: 'error',
            });
          }
        });
    },
    async sendRequestByStatus({ item_id, status, item_type, title }) {
      return API.put(`items/status/${item_id}`, { status, item_type })
        .then((response) => {
          EventBus.$emit('show-toast', {
            message: `Success ${title}`,
            type: 'success',
          });
          setTimeout(() => {
            this.reloadPage();
          }, 3000)
          this.$refs.modalUpdateStatus.hide();

          return response;
        })
        .catch((error) => {
          EventBus.$emit('show-toast', {
            message: `Failed unpublish`,
            type: 'error',
          });
          return error;
        });
    },
    actionUpdateStatus(item, title, status) {
      this.dataItemModalUpateStatus = item
      this.$refs.modalUpdateStatus.show();
      this.titleModalUpdateStatus = title;
      this.statusModalUpdate = status;
      this.nameModalUpdateStatus = item.name
    },
    async confirmUpdateStatus() {
      await this.sendRequestByStatus({
        item_id: this.dataItemModalUpateStatus.id,
        status: this.statusModalUpdate,
        item_type: this.dataItemModalUpateStatus.item_type,
        title: this.titleModalUpdateStatus,
      })
    },
    permBtnMcGraw() {
      switch (this.auth?.role_id) {
        case ROLES.SUPER_ADMIN:
          return true;
        case ROLES.INTERNAL_ADMIN:
          return true;
        case ROLES.INTERNAL_DATA_ENTRY:
          return true;
        default:
          if (McGrawHill.includes(this.ownVendor?.id)) return true;
          return false;
      }
    },
    findIndexRowMcGrawHill(items = []) {
      const statusMcGrawhill = this.status.UnpublishedMcgrawhill;
      return items
        .map((item, idx) => {
          if (item.item_status == statusMcGrawhill) {
            return idx;
          }
        })
        .filter((val) => ![undefined, null].includes(val));
    },
    unselectRowByIndex(indexItem = []) {
      indexItem.forEach((index) => {
        this.$refs.tableList.unselectRow(index);
      });
    },

    onSelectAllRows() {
      if (!this.books) return;
      if (this.isSelectAll) {
        this.selectedItem = this.books.map(book => book.id);
      } else {
        this.selectedItem = [];
      }
    },
   
    formatBoolean(value) {
      return value ? 'Active' : 'Inactive';
    },
    formatterDate: (value) => {
      return moment(value).format('DD MMM YYYY');
    },
     dataSelect(row) {
      console.log(row)
  },
    onRowSelected(rowId) {
      // const index = this.selectedItem.indexOf(rowId);
      console.log('rowId',rowId)
      // if (index > -1) {
      //   this.selectedItem && this.selectedItem.includes(rowId);
      //   this.selectedItem.splice(index, 1);
      // } else {
      //   this.selectedItem.push(rowId);
      // }
    },

    async confirmBulkUnPublish() {
      this.$refs.confirmationModal.show();
      this.confirm()
      this.cancel()
    },
    confirm() {
      this.confirmed = true
      const items_id = this.selectedItem;
      this.isLoadingUnPublish = true;
      this.bulkUnPublish({ items_id })
        .then((response) => {
          this.$refs.confirmationModal.hide();
          if (response.status == 201) {
            EventBus.$emit('show-toast', {
              message: 'Success Unpublished',
              type: 'success',
            });
          } else {
            EventBus.$emit('show-toast', {
              message: 'Success Unpublished',
              type: 'error',
            });
          }
        })
        .catch(() => {
          const message =
            'Opps .. Something is wrong,please contact your administrator';
          this.$swal('Process Failed', message, 'error');
        })
        .finally(() => {
          this.isLoadingUnPublish = false;
          this.reloadPage();
        });

    },

    cancel() {
      this.$refs.confirmationModal.hide();
      this.$refs.modalUpdateStatus.hide();
      this.selectedItem = []
    },

    sortBy(criteria) {
      this.sortOrder = this.sortOrder === 'asc' ? 'desc' : 'asc';
      const queryParam = {
        criteria: criteria,
        order: this.sortOrder
      }
      this.$emit('sort-by', queryParam);
    },
    async onSubmitUnPublishSelected() {
      this.$refs.confirmationModal.show();
    },
  },
};
</script>
